var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColoredWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 20H4.00006C3.64156 20 3.31156 19.8085 3.13306 19.498C2.95506 19.1875 2.95606 18.8055 3.13656 18.496L11.1366 4.496C11.3156 4.189 11.6446 4 12.0001 4C12.3556 4 12.6846 4.189 12.8641 4.496L20.8641 18.496C21.0446 18.8055 21.0456 19.1875 20.8676 19.498C20.6896 19.8085 20.3581 20 20.0001 20Z",
    fill: "#F9DB9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.071C11 16.9365 11.0235 16.8135 11.0715 16.698C11.1185 16.584 11.186 16.485 11.273 16.402C11.3585 16.318 11.464 16.2525 11.585 16.2055C11.707 16.1595 11.844 16.135 11.997 16.135C12.15 16.135 12.288 16.1595 12.411 16.2055C12.536 16.2525 12.6415 16.318 12.727 16.402C12.8145 16.485 12.882 16.584 12.9285 16.698C12.9765 16.8135 13 16.9365 13 17.071C13 17.206 12.9765 17.329 12.9285 17.441C12.8815 17.5535 12.814 17.6505 12.727 17.735C12.6415 17.818 12.536 17.883 12.411 17.931C12.288 17.977 12.15 18 11.997 18C11.8435 18 11.707 17.977 11.585 17.9305C11.464 17.8825 11.3585 17.8175 11.273 17.7345C11.1855 17.65 11.118 17.553 11.0715 17.4405C11.0235 17.3285 11 17.2055 11 17.071ZM12.74 15H11.2535L11.043 9H12.95L12.74 15Z",
    fill: "#916208"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredWarning);
export default __webpack_public_path__ + "static/media/colored-warning.5ab1f5df55f402009bf7715dfd78180e.svg";
export { ForwardRef as ReactComponent };